import { SpinnerService } from './spinner.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  showSpinner = false;

  constructor(private _spinner: SpinnerService, private _cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.init();
  }

  init() {
    this._spinner.getSpinnerObserver().subscribe((status) => {
      this.showSpinner = (status === 'start');
      this._cdRef.detectChanges();
    })
  }


}
